export default "__VITE_ASSET__DucP15o6__"